{
  "version": 2,
  "defaultProfile": "classic",
  "profiles": {
    "classic": {
      "label": "WoW Forever | Original Classic classes and talent trees",
      "classes": {
        "2": ["Balance", "Feral", "Restoration"],
        "3": ["Beast Mastery", "Marksmanship", "Survival"],
        "4": ["Arcane", "Fire", "Frost"],
        "6": ["Holy", "Protection", "Retribution"],
        "7": ["Discipline", "Holy", "Shadow"],
        "8": ["Assassination", "Combat", "Subtlety"],
        "9": ["Elemental", "Enhancement", "Restoration"],
        "10": ["Affliction", "Demonology", "Destruction"],
        "11": ["Arms", "Fury", "Protection"]
      }
    },
    "historicalClassic": {
      "label": "Historical Classic logs | Expansion specs and WCL role labels",
      "classes": {
        "1": ["Blood", "Frost", "Unholy"],
        "2": ["Balance", "Feral", "Guardian", "Restoration", "Warden", "Dreamstate"],
        "3": ["Beast Mastery", "Marksmanship", "Survival"],
        "4": ["Arcane", "Fire", "Frost"],
        "5": ["Brewmaster", "Mistweaver", "Windwalker"],
        "6": ["Holy", "Protection", "Retribution", "Justicar"],
        "7": ["Discipline", "Holy", "Shadow"],
        "8": ["Assassination", "Combat", "Subtlety"],
        "9": ["Elemental", "Enhancement", "Restoration"],
        "10": ["Affliction", "Demonology", "Destruction"],
        "11": ["Arms", "Fury", "Protection", "Gladiator", "Champion"]
      }
    }
  },
  "canvas": {
    "background": "#101318",
    "panel": "#171C22",
    "text": "#F2EFF8",
    "muted": "#BDC3CE"
  },
  "evidence": {
    "spell": "#EDC483",
    "cooldown": "#B49AFF",
    "gear": "#9ED7A0",
    "method": "#85B9ED"
  },
  "classes": [
    {
      "id": 1,
      "name": "Death Knight",
      "color": "#C41E3A",
      "motif": "rune",
      "specs": {
        "Blood": [
          "#EB687D",
          "rune"
        ],
        "Frost": [
          "#91D9F7",
          "snowflake"
        ],
        "Unholy": [
          "#B2CC68",
          "rune"
        ]
      },
      "backgrounds": {
        "Blood": "death-knight-blood-v1.png",
        "Frost": "death-knight-frost-v1.png",
        "Unholy": "death-knight-unholy-v1.png"
      }
    },
    {
      "id": 2,
      "name": "Druid",
      "color": "#FF9D57",
      "motif": "leaf",
      "specs": {
        "Balance": [
          "#ACAEF7",
          "moon"
        ],
        "Feral": [
          "#E9A66F",
          "claw"
        ],
        "Guardian": [
          "#C6AD8F",
          "shield"
        ],
        "Restoration": [
          "#83D6A0",
          "leaf"
        ],
        "Warden": [
          "#90BBA0",
          "shield"
        ],
        "Dreamstate": [
          "#AFCBBD",
          "moon"
        ]
      },
      "backgrounds": {
        "Restoration": "druid-restoration-v1.png",
        "Balance": "druid-balance-v1.png",
        "Feral": "druid-feral-v1.png",
        "Guardian": "druid-guardian-v1.png",
        "Warden": "druid-warden-v1.png",
        "Dreamstate": "druid-dreamstate-v1.png"
      }
    },
    {
      "id": 3,
      "name": "Hunter",
      "color": "#ABD473",
      "motif": "arrow",
      "specs": {
        "Beast Mastery": [
          "#D8B57B",
          "claw"
        ],
        "Marksmanship": [
          "#B0D6B2",
          "arrow"
        ],
        "Survival": [
          "#EAB17E",
          "arrow"
        ]
      },
      "backgrounds": {
        "Beast Mastery": "hunter-beast-mastery-v1.png",
        "Marksmanship": "hunter-marksmanship-v1.png",
        "Survival": "hunter-survival-v1.png"
      }
    },
    {
      "id": 4,
      "name": "Mage",
      "color": "#7BD6EE",
      "motif": "star",
      "specs": {
        "Arcane": [
          "#C4A0F0",
          "star"
        ],
        "Fire": [
          "#F2A268",
          "flame"
        ],
        "Frost": [
          "#A1DEFA",
          "snowflake"
        ]
      },
      "backgrounds": {
        "Arcane": "mage-arcane-v1.png",
        "Fire": "mage-fire-v1.png",
        "Frost": "mage-frost-v1.png"
      }
    },
    {
      "id": 5,
      "name": "Monk",
      "color": "#73D9AE",
      "motif": "ring",
      "specs": {
        "Brewmaster": [
          "#D5B47A",
          "shield"
        ],
        "Mistweaver": [
          "#95DCC8",
          "leaf"
        ],
        "Windwalker": [
          "#B7D8E5",
          "ring"
        ]
      },
      "backgrounds": {
        "Brewmaster": "monk-brewmaster-v1.png",
        "Mistweaver": "monk-mistweaver-v1.png",
        "Windwalker": "monk-windwalker-v1.png"
      }
    },
    {
      "id": 6,
      "name": "Paladin",
      "color": "#F58CBA",
      "motif": "sun",
      "specs": {
        "Holy": [
          "#F0D995",
          "sun"
        ],
        "Protection": [
          "#B7C9E4",
          "shield"
        ],
        "Retribution": [
          "#EBA090",
          "sword"
        ],
        "Justicar": [
          "#DCB8DE",
          "sun"
        ]
      },
      "backgrounds": {
        "Holy": "paladin-holy-v1.png",
        "Protection": "paladin-protection-v1.png",
        "Retribution": "paladin-retribution-v1.png",
        "Justicar": "paladin-justicar-v1.png"
      }
    },
    {
      "id": 7,
      "name": "Priest",
      "color": "#EDEDF2",
      "motif": "sun",
      "specs": {
        "Discipline": [
          "#E1D0A2",
          "shield"
        ],
        "Holy": [
          "#F4E4B6",
          "sun"
        ],
        "Shadow": [
          "#BB9CDD",
          "moon"
        ]
      },
      "backgrounds": {
        "Discipline": "priest-discipline-v1.png",
        "Holy": "priest-holy-v1.png",
        "Shadow": "priest-shadow-v1.png"
      }
    },
    {
      "id": 8,
      "name": "Rogue",
      "color": "#FFF27A",
      "motif": "sword",
      "specs": {
        "Assassination": [
          "#B5D187",
          "sword"
        ],
        "Combat": [
          "#E9C893",
          "sword"
        ],
        "Outlaw": [
          "#E9C893",
          "sword"
        ],
        "Subtlety": [
          "#B8A1CF",
          "moon"
        ]
      },
      "backgrounds": {
        "Assassination": "rogue-assassination-v1.png",
        "Combat": "rogue-combat-v1.png",
        "Outlaw": "rogue-outlaw-v1.png",
        "Subtlety": "rogue-subtlety-v1.png"
      }
    },
    {
      "id": 9,
      "name": "Shaman",
      "color": "#73A7FF",
      "motif": "bolt",
      "specs": {
        "Elemental": [
          "#EAA879",
          "bolt"
        ],
        "Enhancement": [
          "#9EC7F2",
          "bolt"
        ],
        "Restoration": [
          "#86D3C5",
          "wave"
        ]
      },
      "backgrounds": {
        "Elemental": "shaman-elemental-v1.png",
        "Enhancement": "shaman-enhancement-v1.png",
        "Restoration": "shaman-restoration-v1.png"
      }
    },
    {
      "id": 10,
      "name": "Warlock",
      "color": "#B49AFF",
      "motif": "flame",
      "specs": {
        "Affliction": [
          "#B6CD86",
          "moon"
        ],
        "Demonology": [
          "#BE9CEC",
          "rune"
        ],
        "Destruction": [
          "#B49AFF",
          "flame"
        ]
      },
      "backgrounds": {
        "Destruction": "warlock-destruction-v1.png",
        "Affliction": "warlock-affliction-v1.png",
        "Demonology": "warlock-demonology-v1.png"
      }
    },
    {
      "id": 11,
      "name": "Warrior",
      "color": "#D3AD88",
      "motif": "sword",
      "specs": {
        "Arms": [
          "#DCA98C",
          "sword"
        ],
        "Fury": [
          "#EA9286",
          "sword"
        ],
        "Protection": [
          "#B5C5D5",
          "shield"
        ],
        "Gladiator": [
          "#DCC194",
          "shield"
        ],
        "Champion": [
          "#E4C5A0",
          "sword"
        ]
      },
      "backgrounds": {
        "Arms": "warrior-arms-v1.png",
        "Fury": "warrior-fury-v1.png",
        "Protection": "warrior-protection-v1.png",
        "Gladiator": "warrior-gladiator-v1.png",
        "Champion": "warrior-champion-v1.png"
      }
    },
    {
      "id": 12,
      "name": "Demon Hunter",
      "color": "#C17BE8",
      "motif": "rune",
      "specs": {
        "Havoc": [
          "#B4D58A",
          "claw"
        ],
        "Vengeance": [
          "#DBA080",
          "shield"
        ]
      },
      "backgrounds": {
        "Havoc": "demon-hunter-havoc-v1.png",
        "Vengeance": "demon-hunter-vengeance-v1.png"
      }
    },
    {
      "id": 13,
      "name": "Evoker",
      "color": "#7FC5B5",
      "motif": "wing",
      "specs": {
        "Devastation": [
          "#E49A8E",
          "flame"
        ],
        "Preservation": [
          "#A2D4AA",
          "leaf"
        ],
        "Augmentation": [
          "#D1BB8D",
          "wing"
        ]
      },
      "backgrounds": {
        "Devastation": "evoker-devastation-v1.png",
        "Preservation": "evoker-preservation-v1.png",
        "Augmentation": "evoker-augmentation-v1.png"
      }
    }
  ]
}
